import * as _ from "lodash";
import * as $ from "jquery";
import * as Backbone from "backbone";
import { Utils } from "../../common/utils";
import { ModuleCollection } from "../../collections/Modules";
import { SensorStatus } from "../../common/SensorStatus";
import { SensorConfigCollection } from "../../collections/SensorConfigs";
import { Module } from "../../models/Module";
import { ModuleLayoutCollection } from "../../collections/ModuleLayout";
require('bootstrap-toggle');

// TODO: use updated version of d3 and typings
var d3 = require('d3');
var toposort = require('toposort');

d3.selection.prototype.moveToFront = function () {
    return this.each(function () {
        this.parentNode.appendChild(this);
    });
};

// Misc. variables
var i = 0;
var duration = 300;

var nodeHeight = 176;
var nodeWidth = 176;
var circleRadius = 3;
var circleDistance = 1.4;

var linkColorDark = Utils.colors.grey;//'rgb(114, 160, 205)';
var linkColorLight = "#FFFFFF";
var greenColor = Utils.colors.green;
var yellowColor = Utils.colors.yellow;
var redColor = Utils.colors.red;
var blueColor = Utils.colors.aqua;
var margin = { top: -5, right: -5, bottom: -5, left: -5 };


// define a d3 diagonal projection for use by the node paths later on.
var diagonal = d3.svg.diagonal()
    .projection(function (d) {
        return [d.y, d.x];
    });

interface SystemGraphViewOptions extends Backbone.ViewOptions<Backbone.Model> {
    collection: ModuleCollection;
    initialModuleId: number;
    orgId: number;
    sensorConfigCollection: SensorConfigCollection;
    moduleLayoutCollection: ModuleLayoutCollection;

}

export class SystemGraphView extends Backbone.View<Backbone.Model> {

    private initialModuleId: number = null;
    private orgId: number = null;
    private initial: boolean = true;
    private validlySorted: boolean = false;
    private svg: any = null;
    private container: any = null;
    private tree: any = null;
    private treeRoot: any = null;
    private initialModule: any = null;
    private zoomBehavior: any = null;
    private zooming: boolean = false;
    private lastUserActivity: number = null;
    private renderCheckbox: boolean = true;

    private _switchNode: any;

    moduleConnections: any = null;
    collection: ModuleCollection;
    moduleLayoutCollection: ModuleLayoutCollection;
    sensorConfigCollection: SensorConfigCollection;

    constructor(options?: SystemGraphViewOptions) {
        super(<any>_.extend(options, {
            el: '#status-svg-container',
            events: {}
        }));
        this.show(options);

        // this._switchNode = this.switchNode.bind(this);
        // this.switchNode = _.debounce(() => {
        //     this._switchNode()
        // }, 20, {
        //     'leading': true,
        //     'trailing': false
        // });

        this.recordUserActivity = _.debounce(this.recordUserActivity.bind(this), 1000);
        $(document).on('mousemove', this.recordUserActivity);
        $(document).on('mousedown', this.recordUserActivity);
        $(document).on('scroll', this.recordUserActivity);
    }

    private recordUserActivity() {
        this.lastUserActivity = (new Date()).getTime();
    }

    show(options?: SystemGraphViewOptions) {
        this.collection = options.collection;
        this.moduleLayoutCollection = options.moduleLayoutCollection;
        this.initialModuleId = options.initialModuleId;
        this.orgId = options.orgId;
        this.sensorConfigCollection = options.sensorConfigCollection;
        this.render();
        this.switchNode();
    }

    private sortTree() {
        this.tree.sort((a, b) => {
            return b.name.toLowerCase() < a.name.toLowerCase() ? 1 : -1;
        });
    }

    // A recursive helper function for performing some setup by walking through all nodes
    private static visit(currentNode, visitFn, childrenFn) {
        if (!currentNode) return;

        var children = childrenFn(currentNode);
        if (children) {
            _.each(children, (child) => {
                // A recursive helper function for performing some setup by walking through all nodes
                SystemGraphView.visit(child, visitFn, childrenFn);
            });
        }
        visitFn(currentNode);
    }

    private getHeight() {
        return $(this.el).height() - margin.top - margin.bottom;
    }

    private getWidth() {
        return $(this.el).width() - margin.left - margin.right;
    }

    private setupGraph() {
        var view = this;

        function zoomstarted() {
            view.zooming = true;
        }

        function zoomed() {
            view.container.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
        }

        function zoomended() {
            view.zooming = false;
        }

        view.tree = d3.layout.tree().separation(function () {
            return 1
        });

        view.zoomBehavior = d3.behavior.zoom()
            .scaleExtent([0.1, 2])
            .on("zoomstart", zoomstarted)
            .on("zoom", zoomed)
            .on("zoomend", zoomended)
            .scale(0.7);

        view.svg = d3.select(view.el).append("svg")
            .attr("width", view.getWidth())
            .attr("height", view.getHeight())
            .call(view.zoomBehavior);

        view.container = view.svg.append("g");


        SystemGraphView.visit(view.treeRoot, function (d) {
            if (d.id === view.initialModuleId) view.initialModule = d;
        }, function (d) {
            return d.children && d.children.length > 0 ? d.children : null;
        });

        // Sort the tree initially incase the JSON isn't in a sorted order.
        this.sortTree();
    }

    private centerNode(node) {
        // Make sure we are not zooming right now due to  double click
        if (this.zooming) return;

        var scale = this.zoomBehavior.scale();
        var x = -node.y0;
        x = x * scale + this.getWidth() / 2;
        var y = -node.x0;
        y = y * scale + this.getHeight() / 2;
        d3.select('g').transition()
            .duration(duration)
            .attr("transform", "translate(" + x + "," + y + ")scale(" + scale + ")");
        this.zoomBehavior.scale(scale);
        this.zoomBehavior.translate([x, y]);
    }

    private renderTree() {
        var view = this;
        var root = view.treeRoot;
        root.x0 = view.getHeight() / 2;
        root.y0 = 0;

        // Compute the new height, function counts total children of root node and sets tree height accordingly.
        // This prevents the layout looking squashed when new nodes are made visible or looking sparse when nodes are removed
        // This makes the layout more consistent.
        var levelWidth = [1];
        var childCount = function (level, n) {
            if (n.children && n.children.length > 0) {
                if (levelWidth.length <= level + 1) levelWidth.push(0);

                levelWidth[level + 1] += n.children.length;
                n.children.forEach(function (d) {
                    childCount(level + 1, d);
                });
            }
        };
        childCount(0, root);
        var newHeight = d3.max(levelWidth) * nodeHeight * 2;
        view.tree = view.tree.size([newHeight, view.getWidth() * 3]);

        // Compute the new tree layout.
        var nodes = view.tree.nodes(root).reverse();
        var links = view.tree.links(nodes);

        // Set widths between levels based on maxLabelLength.
        nodes.forEach(function (d) {
            d.y = (d.depth * (nodeHeight * 1.5));
        });

        // Update the nodes…
        var node = view.container.selectAll("g.node")
            .data(nodes, function (d) {
                return d.id || (d.id = ++i);
            });

        // Enter any new nodes at the parent's previous position.
        var nodeEnter = node.enter().append("g")
            .attr("class", function (d) {
                return `node node-module-${d.id}`;
            })
            .attr("transform", function (d) {
                return "translate(" + root.y0 + "," + root.x0 + ")";
            })
            .on('click', function (node) {
                window.location.hash = '#/status/' + view.orgId + '/' + view.collection.installId + '/' + node.id;
                view.centerNode(node);

                // Change module select when clicking on node directly.
                const moduleSelect = $('.status-select-module');
                const currentModuleId = Number(moduleSelect.val());
                if (currentModuleId !== node.id) {
                    moduleSelect.val(node.id.toString());
                    moduleSelect.trigger('change');
                }
            });

        this.setNodeEnter(nodeEnter);

        // Transition nodes to their new position.
        var nodeUpdate = node.transition()
            .duration(duration)
            .attr("transform", function (d) {
                return "translate(" + d.y + "," + d.x + ")";
            });

        this.setNodeUpdate(nodeUpdate);

        // Transition exiting nodes to the parent's new position.
        var nodeExit = node.exit().transition()
            .duration(duration)
            .attr("transform", function (d) {
                return "translate(" + root.y + "," + root.x + ")";
            })
            .remove();

        nodeExit.select("text")
            .style("fill-opacity", 0);


        this.setLinks(links, root);

        // Stash the old positions for transition.
        nodes.forEach(function (d) {
            d.x0 = d.x;
            d.y0 = d.y;
        });
    }

    private setLinks(links, root) {
        var view = this;

        // Update the links…
        var link = view.container.selectAll("g.link")
            .data(links, function (d) {
                return d.target.id;
            });

        // Enter any new links at the parent's previous position.
        var linkEnter = link.enter().insert('g', 'g')
            .attr("class", "link");

        linkEnter.insert("path", "g")
            .attr("d", function (d) {
                var o = {
                    x: root.x0,
                    y: root.y0
                };
                return diagonal({
                    source: o,
                    target: o
                });
            });

        var linkStatusFontSize = 13;
        linkEnter.append("text")
            .attr("x", 0)
            .attr("y", 0)
            .attr("dy", .35 * linkStatusFontSize);

        // Transition links to their new position.
        var linkTransition = link.transition().duration(duration);
        linkTransition.select("path")
            .style("stroke", linkColorDark)
            .style("stroke-opacity", function (d) {
                return d.target.link / 150 + 0.25;
            })
            .style("stroke-width", function (d) {
                return (d.target.link / 5 + 8)
            })
            .style("stroke-dasharray", function (d) {
                return d.target.link < 30 ? "10,10" : "10,0.001";
            });
        linkTransition.select("path").attr("d", diagonal);
        linkTransition.select("text")
            .style('fill', function (d) {
                return d.target.link < 30 ? linkColorDark : linkColorLight;
            })
            .attr("text-anchor", 'middle')
            .text(function (d) {
                return d.target.link
            })
            .style("fill-opacity", 1)
            .style("font-size", linkStatusFontSize)
            .style("font-weight", 700)
            .attr("transform", function (d) {
                return "translate(" + (d.source.y + 0.5 * (d.target.y - d.source.y)) + "," + (d.source.x + 0.5 * (d.target.x - d.source.x)) + ")";
            });

        // Transition exiting links to the parent's new position.
        var linkExit = link.exit().transition().duration(duration);
        linkExit.select("path").attr("d", function (d) {
            var o = {
                x: root.x,
                y: root.y
            };
            return diagonal({
                source: o,
                target: o
            });
        });
        linkExit.select("text").style("fill-opacity", 0);
    }

    private setNodeEnter(nodeEnter) {
        var view = this;
        nodeEnter.append("rect")
            .attr('class', 'status-svg-node')
            .attr("height", nodeHeight)
            .attr("width", nodeWidth)
            .attr("x", -nodeHeight / 2)
            .attr("y", -nodeHeight / 2)
            .attr("ry", nodeHeight * .17)
            .style("fill", greenColor)
            .style("stroke", greenColor);

        // Top circles
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con4-1')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(" + Math.floor(-1 * (circleDistance + circleRadius)) + ",-" + Math.floor((nodeHeight / 2) - 6) + ")";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con4)
            });
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con4-2')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(" + Math.floor(-3 * (circleDistance + circleRadius)) + ",-" + Math.floor((nodeHeight / 2) - 6) + ")";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con4)
            });
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con4-3')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(" + Math.floor(3 * (circleDistance + circleRadius)) + ",-" + Math.floor((nodeHeight / 2) - 6) + ")";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con4)
            });
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con4-4')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(" + Math.floor(1 * (circleDistance + circleRadius)) + ",-" + Math.floor((nodeHeight / 2) - 6) + ")";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con4)
            });
        // Right circles
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con1-1')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(" + Math.floor((nodeWidth / 2) - 6) + ",0)";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con1)
            });
        // Bottom circles
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con3-1')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(0," + Math.floor((nodeHeight / 2) - 6) + ")";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con3)
            });
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con3-2')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(" + Math.floor(-2 * (circleDistance + circleRadius)) + "," + Math.floor((nodeHeight / 2) - 6) + ")";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con3)
            });
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con3-3')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(" + Math.floor(2 * (circleDistance + circleRadius)) + "," + Math.floor((nodeHeight / 2) - 6) + ")";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con3)
            });
        // Left circles
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con2-1')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(-" + Math.floor((nodeWidth / 2) - 8) + ", " + Math.floor(1 * (circleDistance + circleRadius)) + ")";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con2)
            });
        nodeEnter.append("circle")
            .attr('class', 'status-svg-node-circle status-svg-node-circle-con2-2')
            .attr('r', Math.floor(circleRadius))
            .attr("transform", function (d) {
                return "translate(-" + Math.floor((nodeWidth / 2) - 8) + ", " + Math.floor(-1 * (circleDistance + circleRadius)) + ")";
            })
            .style('fill-opacity', function (d) {
                return Number(d.con2)
            });

        var moduleNumberFontSize = 26;
        var locationFontSize = 18;
        nodeEnter.append("text")
            .attr("x", 0)
            .attr("y", -nodeHeight / 4)
            .attr("dy", 0)
            .attr('class', 'nodeText')
            .attr("text-anchor", 'middle')
            .text(function (d) {
                return d.name;
            })
            .style("fill-opacity", 0)
            .style("font-size", function (d) {
                return d.name.length <= 10 ? moduleNumberFontSize : locationFontSize;
            })
            .style("font-weight", 500);

        nodeEnter.append("text")
            .attr("x", 0)
            .attr("y", 0)
            .attr("dy", -locationFontSize / 2 - 2)
            .attr('class', 'nodeText nodeText-location1')
            .attr("text-anchor", 'middle')
            .text(function (d) {
                return d.location1
            })
            .style("fill-opacity", 1)
            .style("font-size", locationFontSize)
            .style("font-weight", 300);
        nodeEnter.append("text")
            .attr("x", 0)
            .attr("y", 0)
            .attr("dy", locationFontSize / 2 + 2)
            .attr('class', 'nodeText nodeText-location2')
            .attr("text-anchor", 'middle')
            .text(function (d) {
                return d.location2
            })
            .style("fill-opacity", 1)
            .style("font-size", locationFontSize)
            .style("font-weight", 300);

        var statusFontSize = 18;
        nodeEnter.append("text")
            .attr("x", 0)
            .attr("y", (nodeHeight * .25))
            .attr("dy", statusFontSize)
            .attr('class', 'nodeText nodeText-status')
            .attr("text-anchor", 'middle')
            .style("fill-opacity", 1)
            .style("font-size", statusFontSize)
            .style("font-weight", 500);
    }

    private setNodeUpdate(nodeUpdate) {
        var view = this;

        // Fade the text in
        nodeUpdate.select("text").style("fill-opacity", 1);

        // Fade sensor connector circles in/nodesout
        nodeUpdate.select("circle.status-svg-node-circle-con1-1").style("fill-opacity", function (d) {
            return Number(d.con1)
        });
        nodeUpdate.select("circle.status-svg-node-circle-con2-1").style("fill-opacity", function (d) {
            return Number(d.con2)
        });
        nodeUpdate.select("circle.status-svg-node-circle-con2-2").style("fill-opacity", function (d) {
            return Number(d.con2)
        });
        nodeUpdate.select("circle.status-svg-node-circle-con3-1").style("fill-opacity", function (d) {
            return Number(d.con3)
        });
        nodeUpdate.select("circle.status-svg-node-circle-con3-2").style("fill-opacity", function (d) {
            return Number(d.con3)
        });
        nodeUpdate.select("circle.status-svg-node-circle-con3-3").style("fill-opacity", function (d) {
            return Number(d.con3)
        });
        nodeUpdate.select("circle.status-svg-node-circle-con4-1").style("fill-opacity", function (d) {
            return Number(d.con4)
        });
        nodeUpdate.select("circle.status-svg-node-circle-con4-2").style("fill-opacity", function (d) {
            return Number(d.con4)
        });
        nodeUpdate.select("circle.status-svg-node-circle-con4-3").style("fill-opacity", function (d) {
            return Number(d.con4)
        });
        nodeUpdate.select("circle.status-svg-node-circle-con4-4").style("fill-opacity", function (d) {
            return Number(d.con4)
        });

        // Transition the color of the node
        nodeUpdate.select('rect')
            .style("fill", function (d) {
                SystemGraphView.visit(view.treeRoot,
                    (currentNode) => {
                        _.each(currentNode.children, (child: any) => {
                            if (!currentNode.inUse) {
                                if (child.status !== "danger" && child.status !== "warning") {
                                    currentNode.status = "success";
                                    currentNode.statusText = "Transferring Data";
                                    return;
                                }
                            }
                        })
                    },
                    (d) => {
                        return d.children && d.children.length > 0 ? d.children : null;
                    });
                if (d.status === "danger") {
                    return redColor;
                } else if (d.status === "warning") {
                    return yellowColor;
                } else if (d.status === "info") {
                    return blueColor;
                } else {
                    return greenColor;
                }
            }).style("stroke", function (d) {
                if (d.status === "danger") {
                    return redColor;
                } else if (d.status === "warning") {
                    return yellowColor;
                } else if (d.status === "info") {
                    return blueColor;
                } else {
                    return greenColor;
                }
            });
        nodeUpdate.select('text.nodeText-status')
            .text(function (d) {
                return d.statusText
            });
        nodeUpdate.select('text.nodeText-location1')
            .text(function (d) {
                return d.location1
            });
        nodeUpdate.select('text.nodeText-location2')
            .text(function (d) {
                return d.location2
            });
    }

    private buildTreeData() {
        var gw = <Module>this.collection.getGateway();
        var gwModuleNumber = String(gw.get('module_number'));
        // var edges: Array<string | string[]> = [];
        // var tree: Map<string, object> = new Map<string, object>();
        var edges = [];
        var tree = {};
        const layoutView = $('.show-layout-view').is(':checked');

        // Sort collection topologically and build tree from edges
        for (var i = 0; i < this.collection.models.length; i++) {
            if (this.collection.models[i].isVirtualModule()) continue;

            var depends = String(this.collection.models[i].getChannelValue(0, 5, ''));
            var moduleNumber = String(this.collection.models[i].get('module_number'));

            var loc = this.collection.models[i].get('module_location').split(' ');
            var lq = this.collection.models[i].getLinkQuality();
            var sensorStatus = new SensorStatus({
                sensorConfigCollection: this.sensorConfigCollection,
                moduleModel: this.collection.models[i],
            });

            var moduleStatus = sensorStatus.getCombinedStatus(null, 0);
            tree[moduleNumber] = {
                name: this.collection.models[i].get('module_number'),
                id: this.collection.models[i].get('module_id'),
                location1: loc.slice(0, loc.length / 2).join(' '),
                location2: loc.slice(loc.length / 2).join(' '),
                con1: this.collection.models[i].showConnector(1),
                con2: this.collection.models[i].showConnector(2),
                con3: this.collection.models[i].showConnector(3),
                con4: this.collection.models[i].showConnector(4),
                link: lq === false ? '' : lq,
                status: moduleStatus['graphStatus'],
                statusText: moduleStatus['graphDescription'],
                inUse: this.collection.models[i].connectorInUse(0),
                children: []
            };

            if (depends !== null && depends !== '0' && depends.length !== 0) {
                edges.push([moduleNumber, depends]);
                tree[moduleNumber]['depends'] = depends;
            } else {
                // Fall back behaviour if a node doesn't publish a neighbor, or if it's a gateway
                // If it's a node make it depend on the gateway
                if (!this.collection.models[i].isGateway()) {
                    // If it's the layout view, do not cerate dependencies for the connections
                    // since they are not needed to draw the graph
                    tree[moduleNumber]['depends'] = layoutView ? '' : gwModuleNumber;
                    edges.push([moduleNumber, gwModuleNumber]);
                } else {
                    tree[moduleNumber]['depends'] = [];
                }
            }
        }
        this.moduleConnections = [tree, edges]
        try {
            //From 2D array of edges to 1D
            edges = toposort(edges);
            this.validlySorted = true;
        } catch (e) {
            // Cyclic dependencies can occur when modules go down and dependent modules
            // are in the process of finding another node to talk to
            if (this.validlySorted && this.treeRoot !== null) {
                return;
            } else if (this.validlySorted && this.treeRoot === null) {
                console.log("No treeRoot despite valid sort (this, edges, tree)", this, edges, tree);
            }
            // Naively deal with cyclic dependencies by making eveything dependent on the gateway
            edges = [];
            _.each(tree, function (module: {}, moduleNumber) {
                // If it's the layout view, do not cerate dependencies for the connections
                // since they are not needed to draw the graph
                module['depends'] = (moduleNumber === gwModuleNumber) || layoutView ? '' : gwModuleNumber;
                edges.push(moduleNumber);
            });
            this.moduleConnections = [tree, edges]
        }

        if (edges.length) {
            for (let j = 0; j < edges.length; j++) {
                const treePath = edges[j];
                if (_.has(tree, treePath)) {
                    const currentModule = _.get(tree, treePath);
                    const dependencyModuleNumber: string = currentModule['depends']
                    if (_.has(tree, dependencyModuleNumber)) {
                        const dependency = _.get(tree, dependencyModuleNumber);
                        dependency['children'].push(currentModule);
                    } else if (treePath !== gwModuleNumber) {
                        // Modules dependent on e.g. removed modules will cause the graph to fail to render
                        // until they send a new data point with their new dependency. Instead of letting the graph
                        // fail, just make the modules dependent on the gateway
                        tree[gwModuleNumber]['children'].push(currentModule);
                    }
                }
            }
            tree = tree[gwModuleNumber];
        } else {
            // If there is only one module, there won't be any edges
            tree = tree[moduleNumber];
        }
        this.treeRoot = tree;
        if (this.treeRoot === null) {
            console.log("treeRoot set to null (this, edges)", this, edges)
        }
    }

    public switchNode() {
        var now = (new Date().getTime());

        if (this.initial) {
            this.buildTreeData();

            this.setupGraph();

            this.initial = false;
            window.requestAnimationFrame(() => {
                this.renderTree();
                this.centerNode(this.initialModule);
            });
        } else if ((now - this.lastUserActivity) < 300000) {
            this.buildTreeData();
            // The user was active in the last 5 minutes
            window.requestAnimationFrame(() => {
                this.renderTree();
            });
        }
    }

    private onTouchMove(e) {
        // Explicitly stop the propagation of the touch scoll-event inside the system graph for iOS
        e.preventDefault();
    }

    render() {
        if (!this.$el.is(':visible')) {
            return;
        }

        if (this.initial) {
            this.$el.on('touchmove', this.onTouchMove);
        }
        // if(this.renderCheckbox) {
        //     this.$el.on('touchmove', this.onTouchMove);
        //     this.$el.append('<div class="row hspace-20">\n' +
        //         '        <div class="col-sm-6 col-xs-6">\n' +
        //         '            <input type="checkbox" class="show-layout-view pull-right" data-width="100" data-toggle="toggle"\n' +
        //         '                   data-on="Layout View"\n' +
        //         '                   data-off="Default View" data-size="small">\n' +
        //         '        </div>\n' +
        //         '    </div>');
        //     (<any>this.$('[data-toggle="toggle"]')).bootstrapToggle();

        //     this.renderCheckbox = false;
        // }

        setTimeout(this.switchNode, 0);
        if (this.initial && $(document).height() >= 720 && $(document).width() >= 975) {
            // Set to fix width and affix if the client height supports it
            (<any>this.$el.width(this.$el.width())).affix({
                offset: {
                    top: this.$el.offset().top - 50
                }
            });
        }

        return this;
    }

    remove() {
        $(document).off('mousemove', this.recordUserActivity);
        $(document).off('mousedown', this.recordUserActivity);
        $(document).off('scroll', this.recordUserActivity);

        this.$el.off('touchmove', this.onTouchMove);

        return super.remove();
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/views/status/SystemGraphView.ts